export const transparent = "transparent";
export const current = "currentColor";
export const black = "#000";
export const white = "#fff";
export const gray100 = "#f7fafc";
export const gray200 = "#edf2f7";
export const gray300 = "#e2e8f0";
export const gray400 = "#cbd5e0";
export const gray500 = "#a0aec0";
export const gray600 = "#718096";
export const gray700 = "#4a5568";
export const gray800 = "#2d3748";
export const gray900 = "#1a202c";
export const red100 = "#fff5f5";
export const red200 = "#fed7d7";
export const red300 = "#feb2b2";
export const red400 = "#fc8181";
export const red500 = "#f56565";
export const red600 = "#e53e3e";
export const red700 = "#c53030";
export const red800 = "#9b2c2c";
export const red900 = "#742a2a";
export const orange100 = "#fffaf0";
export const orange200 = "#feebc8";
export const orange300 = "#fbd38d";
export const orange400 = "#f6ad55";
export const orange500 = "#ed8936";
export const orange600 = "#dd6b20";
export const orange700 = "#c05621";
export const orange800 = "#9c4221";
export const orange900 = "#7b341e";
export const yellow100 = "#fffff0";
export const yellow200 = "#fefcbf";
export const yellow300 = "#faf089";
export const yellow400 = "#f6e05e";
export const yellow500 = "#ecc94b";
export const yellow600 = "#d69e2e";
export const yellow700 = "#b7791f";
export const yellow800 = "#975a16";
export const yellow900 = "#744210";
export const green100 = "#f0fff4";
export const green200 = "#c6f6d5";
export const green300 = "#9ae6b4";
export const green400 = "#68d391";
export const green500 = "#48bb78";
export const green600 = "#38a169";
export const green700 = "#2f855a";
export const green800 = "#276749";
export const green900 = "#22543d";
export const teal100 = "#e6fffa";
export const teal200 = "#b2f5ea";
export const teal300 = "#81e6d9";
export const teal400 = "#4fd1c5";
export const teal500 = "#38b2ac";
export const teal600 = "#319795";
export const teal700 = "#2c7a7b";
export const teal800 = "#285e61";
export const teal900 = "#234e52";
export const blue100 = "#ebf8ff";
export const blue200 = "#bee3f8";
export const blue300 = "#90cdf4";
export const blue400 = "#63b3ed";
export const blue500 = "#4299e1";
export const blue600 = "#3182ce";
export const blue700 = "#2b6cb0";
export const blue800 = "#2c5282";
export const blue900 = "#2a4365";
export const indigo100 = "#ebf4ff";
export const indigo200 = "#c3dafe";
export const indigo300 = "#a3bffa";
export const indigo400 = "#7f9cf5";
export const indigo500 = "#667eea";
export const indigo600 = "#5a67d8";
export const indigo700 = "#4c51bf";
export const indigo800 = "#434190";
export const indigo900 = "#3c366b";
export const purple100 = "#faf5ff";
export const purple200 = "#e9d8fd";
export const purple300 = "#d6bcfa";
export const purple400 = "#b794f4";
export const purple500 = "#9f7aea";
export const purple600 = "#805ad5";
export const purple700 = "#6b46c1";
export const purple800 = "#553c9a";
export const purple900 = "#44337a";
export const pink100 = "#fff5f7";
export const pink200 = "#fed7e2";
export const pink300 = "#fbb6ce";
export const pink400 = "#f687b3";
export const pink500 = "#ed64a6";
export const pink600 = "#d53f8c";
export const pink700 = "#b83280";
export const pink800 = "#97266d";
export const pink900 = "#702459";
